import React, { FC } from 'react';

interface Props {
  className?: string;
  size?: number;
  color?: string;
}

export const AccrualIcon: FC<Props> = ({ className, size = 24, color = 'currentColor' }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13.9792 16.9804V13.9608H14.7708V16.9804H13.9792ZM16.3542 16.9804V13.9608H17.1458V16.9804H16.3542ZM12.7917 18.7059V17.8431H20.7083V18.7059H12.7917ZM18.7292 16.9804V13.9608H19.5208V16.9804H18.7292ZM12.7917 13.098V12.2353L16.75 10.0784L20.7083 12.2353V13.098H12.7917ZM14.5531 12.2353H18.9469L16.75 11.049L14.5531 12.2353Z" />
      <rect x="2.5" y="4" width="13.8182" height="2.5098" />
      <path d="M2.5 9.01962H12.8636L12.5606 9.3499C12.0149 9.94458 11.7121 10.7223 11.7121 11.5294H2.5V9.01962Z" />
      <path d="M2.5 14.0392H11.1364L11.1103 14.1122C10.8312 14.8943 10.6886 15.7186 10.6886 16.549H2.5V14.0392Z" />
    </svg>
  );
};
